import { useSelector } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';

import { JBEnvironmentId } from '@bjb-gcrm/gcrm-frontend-components';
import { GlobalState } from 'reducers/stateTypes';
import { BrChangeHistoryWrapperWC } from '@juliusbaer-gcrm/pcm-br-mgmt-components/BrChangeHistoryWrapperWC';

export interface Props {
  env: JBEnvironmentId;
}

export const ChangeHistoryAction = ({ env }: Props) => {
  const brUid = useSelector((state: GlobalState) => state.caseInformation.accountInformation?.brUid);

  if (!brUid) {
    return undefined;
  }

  return (
    <ErrorBoundary fallback={null}>
      <BrChangeHistoryWrapperWC env={env} version="0.0.0" brUid={brUid} />
    </ErrorBoundary>
  );
};
